'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Filter =

/**
 * Filter instance.
 */
function Filter(id, options) {
  _classCallCheck(this, Filter);

  if (options === undefined) {
    console.log(options);
    throw new Error('The options for the above filter is undefined');
  } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
    console.log(options);
    throw new Error('The options for the above filter is not an object');
  }

  if (id === undefined) {
    console.log(options);
    throw new Error('The id for the above filter is undefined');
  } else if (typeof id !== 'string') {
    console.log(options);
    throw new Error('The id for the above filter is not a string');
  }
  this._id = id;

  if (options.type === undefined) {
    throw new Error('The type option for the \'' + this._id + '\' filter is undefined');
  } else if (typeof options.type !== 'string') {
    throw new Error('The type option for the \'' + this._id + '\' filter is not a string');
  }

  this._type = options.type;
};

exports.default = Filter;
//# sourceMappingURL=../filters/Filter.js.map